<template>
  <span class="d-flex align-items-center">
    <b-badge>
      {{ buildingOwnerData.totalMandateTantiemesChargeGenerale }}
    </b-badge>
    <b-badge
      v-if="buildingOwnerData.reducedMandateTantiemesChargeGenerale"
      class="ml-1"
      variant="warning"
    >
      {{ buildingOwnerData.reducedMandateTantiemesChargeGenerale }}
    </b-badge>
  </span>
</template>

<script>
export default {
  props: {
    buildingOwnerData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>
